import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../../modules/SimpleInput";
import Api from "../../../../../Services/Api";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import { HttpStatus, INITIAL_PAGINATION } from "../../../../common/Constants";
import { modalProspectTableConfig } from "./config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ModalProspect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      searchValue: null,
      pagination: INITIAL_PAGINATION,
      skipFetch: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;

    console.log(currPagination);

    if (
      (currPagination.limit !== prevPagination.limit ||
      currPagination.page !== prevPagination.page) &&
      !this.state.skipFetch
    ) {
      this.fetchData(this.state.searchValue);
    }

    if(this.state.skipFetch){
      this.setState({skipFetch: false});
    }
  }

  fetchData = async (keyword) => {
    const { onTriggerLoading, formData } = this.props;
    const { pagination } = this.state;

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getProspectForSalesOrder,
      setError: this.props.setError,
      menuName: "Faktur Jual - Data Unit",
      args: contructQueryParam({
        kodeCabang: formData?.kodeCabang?.value,
        category: "H23",
        page: pagination.page,
        limit: pagination.limit,
        ...(keyword ? { customerName: keyword } : {}),
      }),
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable:
          res?.data?.data?.map((item) => {
            return {
              prospectNo: item.nomorProspek,
              pemilikProspek: item.pemilikProspek,
              jenisProspect: item.jenisProspek,
              name: item.nama,
              hpNumber1: item.telepon,
              address: item.alamat,
              provinceId: item.provinsi?.provinceName,
              kecamatanId: item.kecamatan?.kecamatanName,
              kelurahanId: item.kelurahan?.kelurahanname,
            };
          }) || [],
          pagination: {
            ...prev.pagination,
            totalData: res.data.totalData,
          },
      }));
    }
  };

  handleChangePage = (tableState) => {
    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 0,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  submitSearch = async (keyword) => {
    await this.setState((prev)=>({...prev, pagination:INITIAL_PAGINATION, skipFetch: true}));
    this.fetchData(keyword);
  };

  handleSelectProspect = (rowIndex) => {
    const { dataTable } = this.state;
    const { onChangeData, onClickClose } = this.props;
    onChangeData("noProspect", dataTable[rowIndex].prospectNo);
    onChangeData("jenisProspect", dataTable[rowIndex].jenisProspect);
    onClickClose();
  };

  getTableColumns = () => {
    return modalProspectTableConfig({
      onSelect: this.handleSelectProspect,
    });
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { searchValue, dataTable, pagination } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="List Data prospek"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView vAlignContent="center">
                <h4 className="txt-site txt-11 txt-main txt-bold margin-bottom-20px">
                  Nama Prospek
                </h4>
                <SimpleInput
                  id="consumenName"
                  placeholder="Nama Konsumen"
                  value={searchValue}
                  containerclassname="width width-250px margin-left-10px"
                  onChange={({ target }) =>
                    this.setState({ searchValue: target.value })
                  }
                />
                <SimpleButton
                  id="btn_consumen_name"
                  className="margin-bottom-20px"
                  text="Cari"
                  onClick={() => this.submitSearch(searchValue)}
                />
              </FlexView>
              <SimpleDataTable
                data={dataTable}
                columns={this.getTableColumns()}
                toCount={pagination.totalData}
                rowsPerPage={pagination.limit}
                page={pagination.page - 1}
                options={defaultTableChange(
                  this.handleChangePage,
                  this.handleRowsPerPage
                )}
              />
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default ModalProspect;
